import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=22bd5bf3&"
import script from "./message.js?vue&type=script&lang=js&"
export * from "./message.js?vue&type=script&lang=js&"
import style0 from "./Message.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports